module.exports = __webpack_public_path__ + "static/media/premlogo.07e80ae4.png";